import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import e, { useState as t, useEffect as n } from "react";
function i(e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;
  if (e && "undefined" != typeof document) {
    var i = document.head || document.getElementsByTagName("head")[0],
      a = document.createElement("style");
    a.type = "text/css", "top" === n && i.firstChild ? i.insertBefore(a, i.firstChild) : i.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}
i(".quantity-picker{display:inline-block;border:1px solid #dfdfdf;border-radius:3px;vertical-align:middle}.quantity-input:focus{background:red}.quantity-display,.quantity-modifier{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:none}.quantity-modifier{height:100%;width:3rem;font-size:1.5rem;background:#f3f3f3;color:#888;border:0 solid #dbdbdb;text-align:center;cursor:pointer}.quantity-modifier:hover{background:#dadada;color:#555}.quantity-modifier:focus{outline:0}.left-modifier{border-radius:3px 0 0 3px}.mod-disable{color:#e0e0e0}.mod-disable:hover{background-color:#f3f3f3!important;color:#e0e0e0}.right-modifier{border-radius:0 3px 3px 0}.quantity-display{width:4rem;padding:.5rem;font-size:1.5rem;border:0;border-top:0 solid #dbdbdb;border-bottom:0 solid #dbdbdb;text-align:center}");
i('[data-quantity]{position:relative;width:100%;max-width:11rem;padding:0;margin:0;border:0}[data-quantity] legend{display:none}[data-quantity] input{font-size:16px;height:2.3rem;padding:0 3.1rem;margin-top:.6rem;border-radius:2rem;border:0;background:#fff;color:#222;box-shadow:0 5px 45px -10px rgba(0,0,0,.25);text-align:center;width:100%;box-sizing:border-box;font-weight:lighter}[data-quantity] input:focus{outline:none;box-shadow:0 5px 55px -10px rgba(0,0,0,.2),0 0 4px #3fff7f}[data-quantity] input[type=number]::-webkit-inner-spin-button,[data-quantity] input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}[data-quantity] input[type=number]{-moz-appearance:textfield}[data-quantity] button{position:absolute;width:2.5rem;height:2.5rem;top:.5rem;display:block;padding:0;margin:0;border:0;background:#e3e2e5 url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="50"><path d="M17 25h16M67 25h16M75 17v16" fill="none" stroke="rgb(59,69,66)" stroke-width="1.5px" stroke-linecap="round" stroke-linejoin="round" /></svg>\') no-repeat 0 0;background-size:4.6rem 2.2rem;overflow:hidden;white-space:nowrap;text-indent:100%;border-radius:1.4rem;cursor:pointer;transition:opacity .15s;opacity:.7}[data-quantity] button:active{background-position-y:1px;box-shadow:inset 0 2px 12px -4px #c5d1d9}[data-quantity] button:focus{outline:none}[data-quantity] button:hover{opacity:1}[data-quantity] button.sub{left:-.1rem}[data-quantity] button.add{right:-.1rem;background-position-x:-2.2rem}');
var a = function a(i) {
  var _t = t(i.value ? i.value : 0),
    _t2 = _slicedToArray(_t, 2),
    a = _t2[0],
    o = _t2[1],
    r = function r(e) {
      return function (t) {
        var n = Number(a) + 1,
          r = Number(a) - 1;
        switch (e) {
          case "increment":
            (void 0 === i.max || n <= Number(i.max)) && (o(n), i.onChange && i.onChange(n));
            break;
          case "decrement":
            (void 0 === i.min || r >= Number(i.min)) && (o(r), i.onChange && i.onChange(r));
            break;
          case "input":
            (void 0 === i.min && void 0 === i.max || t.target.value >= Number(i.min) && t.target.value <= Number(i.max)) && (isNaN(t.target.value) || (o(t.target.value), i.onChange && i.onChange(t.target.value)));
        }
      };
    };
  return n(function () {
    var e = new AbortController();
    return e.signal, function () {
      e.abort();
    };
  }, []), i.smooth ? e.createElement("div", {
    style: {
      width: i.width ? i.width : "10rem"
    },
    "data-quantity": ""
  }, e.createElement("button", {
    onClick: r("decrement"),
    type: "button",
    title: "Down",
    className: "sub"
  }, "Down"), e.createElement("input", {
    style: {
      width: i.width ? i.width : "10rem"
    },
    value: a,
    type: "number",
    name: "quantity",
    pattern: "[0-9]+",
    onChange: r("input")
  }), e.createElement("button", {
    type: "button",
    title: "Up",
    className: "add",
    onClick: r("increment")
  }, "Up")) : e.createElement("span", {
    className: "quantity-picker"
  }, e.createElement("button", {
    className: (i.disableDec ? "mod-disable " : "") + "quantity-modifier modifier-left",
    onClick: r("decrement")
  }, "–"), e.createElement("input", {
    style: {
      width: i.width ? i.width : "4rem"
    },
    className: "quantity-display",
    type: "text",
    value: a,
    onChange: r("input")
  }), e.createElement("button", {
    className: (i.disableInc ? "mod-disable " : "") + "quantity-modifier modifier-right",
    onClick: r("increment")
  }, "＋"));
};
export { a as QuantityPicker };